<template>
  <div class="flex items-center justify-center">
    <div class="flex border_main4 items-center">
      <div class="item_img flex justify-center">
        <div class="rounded-full">
          <div class="record_img">
            <canvas id="canvas" ref="recordRef" class="canvas canvas_Recognition"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/store/api'
  import Recorder from 'js-audio-recorder'
  import { mapGetters } from 'vuex'
  import recordingBg from '@/assets//image/toeic/toeic_exam/RecognitionS.png'
  export default {
    name: "RecognitionS",
    data () {
      return {
        drawRecordId: null,

        isRecording: false,

        recorderJS: null
      }
    },
    computed: {
      ...mapGetters([
        'remainPoints'
      ])
    },
    beforeDestroy () {
      if (this.isRecording) {
        this.stopRecord()
      }

      if (this.recorderJS) {
        this.recorderJS.destroy().then(() => {
          this.recorderJS = null
        })
      }

      if (this.drawRecordId) {
        cancelAnimationFrame(this.drawRecordId)
        this.drawRecordId = null
      }
    },
    beforeMount () {
      this.safeInitMediaDevices()
    },
    mounted () {
      // this.safeInitMediaDevices()
    },
    methods: {
      async safeInitMediaDevices () {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true })

          if (window.AudioContext) {
            try {
              const ctx = new AudioContext()
              if (ctx.state === 'suspended') await ctx.resume()
              ctx.close() // 關掉測試用的 context
            } catch (e) {
              console.warn('[AudioContext resume 失敗]', e)
            }
          }

          this.startRecord()
        } catch (err) {
          this.handleMicError(err)
        }
      },

      handleMicError (err) {
        const name = err?.name
        if (name === 'NotAllowedError') {
          this.showMicError('請點擊網址列左方的鎖頭圖示，並允許存取麥克風。')
        } else if (name === 'NotFoundError') {
          this.showMicError('未偵測到麥克風裝置，請確認設備已接上或使用其他設備。')
        } else if (name === 'NotReadableError') {
          this.showMicError('麥克風可能被其他應用佔用，請稍後再試。')
        } else if (name === 'SecurityError') {
          this.showMicError('請使用 HTTPS 網站開啟本功能。')
        } else {
          this.showMicError('無法啟用麥克風，請確認裝置與瀏覽器設定。')
          console.error('[錄音錯誤]', err)
        }
      },

      showMicError (text) {
        this.$swal({
          title: "Notice",
          text: text,
          icon: "warning",
          customClass: {
            container: '',
            confirmButton: 'btn-submit gept_main_bg'
          }
        })
      },

      startRecord () {
        try {
          this.recorderJS = new Recorder()
        } catch (err) {
          console.error('[Recorder 初始化失敗]', err)
          this.showMicError('錄音元件初始化失敗，請重新整理或更換瀏覽器。')
          return
        }

        this.recorderJS.start()
          .then(() => {
            this.isRecording = true
            this.drawRecord()
          })
          .catch((err) => {
            console.error('[錄音啟動失敗]', err)
            this.showMicError('無法啟動錄音，請確認麥克風權限與裝置設定')
            this.recorderJS?.stop()
            this.recorderJS?.destroy()
            this.recorderJS = null
            cancelAnimationFrame(this.drawRecordId)
            this.drawRecordId = null
          })
      },

      stopRecord () {
        if (!this.recorderJS) return

        try {
          this.recorderJS.stop()
          this.isRecording = false

          const audioBlob = this.recorderJS.getWAVBlob()
          if (audioBlob) {
            this.$emit('emitAudioData', audioBlob)
          }

        } catch (err) {
          console.error('[stopRecord 發生錯誤]', err)
        } finally {
          try {
            this.recorderJS.destroy()
          } catch (err) {
            console.warn('[recorderJS.destroy() 失敗]', err)
          }

          this.recorderJS = null

          if (this.drawRecordId) {
            cancelAnimationFrame(this.drawRecordId)
            this.drawRecordId = null
          }
        }
      },

      getSTT (audioData) {
        let self = this

        let path = `/ERS?stext=${self.sText}`

        let data = audioData

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: path,
          headers: {
            'Content-Type': 'audio/wave'
          },
          data: data
        }

        api.request(config)
        .then((response) => {
          self.$emit('emitERS', response.data)
        })
        .catch((error) => {
        })
      },

      drawRecord () {
        this.drawRecordId = requestAnimationFrame(() => this.drawRecord())
        this.drawWave({
          canvas: this.$refs.recordRef,
          dataArray: this.recorderJS.getRecordAnalyseData(),
          bgcolor: 'rgb(200, 200, 200, 0)',
          lineWidth: 2,
          lineColor: 'rgb(255, 255, 255)'
        })
      },

      drawWave({
        canvas,
        dataArray,
        bgcolor = 'rgb(200, 200, 200)',
        lineWidth = 2,
        lineColor = 'rgb(0, 0, 0)'
      }) {
        if (!canvas) return
        canvas.width = 50
        canvas.height = 50

        let background = new Image()
        background.src = recordingBg
        background.size = 'contain'

        const ctx = canvas.getContext('2d')
        const bufferLength = dataArray.length
        const sliceWidth = canvas.width / bufferLength
        let x = 0
        ctx.drawImage(background, 0, 0)
        ctx.fillStyle = bgcolor
        ctx.fillRect(0, 0, canvas.width, canvas.height)

        ctx.lineWidth = lineWidth
        ctx.strokeStyle = lineColor

        ctx.beginPath()

        for (let i = 0; i < bufferLength; i++) {
          const v = dataArray[i] / 128
          const y = (v * canvas.height) / 2

          if (i === 0) {
            ctx.moveTo(x, y)
          } else {
            ctx.lineTo(x, y)
          }
          x += sliceWidth
        }

        ctx.lineTo(canvas.width, canvas.height / 2)
        ctx.stroke()
      },

      stopAction () {
        let self = this
        self.$emit('stopAction')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .canvas {
    background-image: url('~@/assets//image/toeic/toeic_exam/RecognitionS.png');
    background-repeat: no-repeat;
    background-size: contain;
  }
  .voice_stop {
    right: 5%;
    bottom: -5%;
    z-index: 2;
  }
  .record_img {
    width: 50px;
    height: 50px;
    background-image: url('~@/assets//image/toeic/toeic_exam/RecognitionS.png');
    background-size: 50px;
  }
  .canvas_Recognition {
    width: 100%;
    height: 100%;
    max-width: 50px;
    max-height: 50px;
  }
  .onreconation_icon {
    transform: translate(-50%, -50%);
    animation: move 2s linear infinite;
    transform-origin: center;
  }
  @keyframes move {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>